import {memo, useEffect, useState} from 'react';

import Loading from '@components/Loading';
import MessageComponent from '@components/common/MessageComponent';
import {api} from '@utils/api';
import {cartData} from '@utils/functions';

const PromoCode = props => {
	const {styles, data, error, session, dispatch} = props;
	const [voucher, setVoucher] = useState({
		code: data && data.code ? data.code : '',
		value: '',
		specificValue: '',
		maxDiscount: 0,
		loading: false,
		error: null,
	});

	useEffect(() => {
		let maxDiscount = '';
		if (data) {
			maxDiscount = data.orderTotal > data.value ? data.value : data.orderTotal;
		}
		setVoucher(val => ({
			...val,
			code: data && data.code ? data.code : '',
			specificValue: data && data.discount ? data.discount : '',
			maxDiscount,
		}));
	}, [data]);

	useEffect(() => {
		setVoucher(val => ({
			...val,
			error: (error && error.promo) || null,
		}));
	}, [error]);

	const promoAction = async (action, useType = null) => {
		let error = null;
		if (voucher.code.trim() === '') {
			setVoucher(val => ({...val, error: 'Please enter a code.'}));
			error = 'Please enter a code.';
		} else {
			const data = {
				code: voucher.code,
			};

			if (useType) {
				data.useType = useType;

				if (useType === 'full') {
					data.specificValue = data.value;
				}

				if (useType === 'specific') {
					if (+voucher.specificValue > voucher.maxDiscount) {
						setVoucher(val => ({
							...val,
							error: `Maximum promo discount is $${voucher.maxDiscount}.`,
						}));
						return false;
					}
					data.specificValue = voucher.specificValue;
				}
			}
			setVoucher(val => ({...val, error: null, loading: true}));
			const res = await api(
				{
					url: '/cart/update',
					method: 'POST',
					data: {
						voucher: action === 'remove' ? {remove: true} : data,
					},
				},
				session,
			);
			if (res.voucher) {
				setVoucher(val => ({
					...val,
					error: res.voucher.message,
					loading: false,
				}));
				error = res.voucher.message;
			} else {
				setVoucher(val => ({...val, error: null, loading: false}));
			}
			if (error) {
				dispatch({
					type: 'SET_ERROR',
					data: {
						error: {promo: error},
					},
				});
			} else {
				const cData = cartData(res);

				dispatch({
					type: 'SET_DATA',
					data: {
						promo: cData.promo,
						total: cData.total,
					},
				});
			}
		}
	};

	return (
		<div className={styles.cupponBlock}>
			<h2>Promotional Code</h2>
			{voucher.loading ? (
				<div className='pt-3 pb-3'>
					<Loading.LineLoader />
				</div>
			) : (
				<>
					{data && data.code && (
						<MessageComponent
							messageKey='mossText'
							message={'Promo code accepted.'}
						/>
					)}
					{voucher.error && (
						<MessageComponent messageKey='error' message={voucher.error} />
					)}
					<div className={`row form-group ${styles.alignItemsCenter}`}>
						<div className='col-8 col-lg-8'>
							<input
								type='text'
								className={`form-control ${styles.formControl}`}
								placeholder='Code here'
								value={voucher.code}
								disabled={data && data.code ? true : false}
								onChange={e =>
									setVoucher(val => ({...val, code: e.target.value}))
								}
							/>
						</div>
						<div className='col-4 col-lg-4'>
							{data && data.code ? (
								<button
									className={`btn ${styles.btnCustom} overcastBtn`}
									onClick={() => promoAction('remove')}
								>
									Remove
								</button>
							) : (
								<button
									className={`btn ${styles.btnCustom} overcastBtn`}
									onClick={() => promoAction('apply')}
								>
									Add
								</button>
							)}
						</div>
					</div>
					{data && data.type === 'giftCard' && (
						<>
							<div className={`row form-group ${styles.alignItemsCenter}`}>
								<div className='col-12 col-lg-12'>
									<select
										name='useType'
										className='form-control'
										onChange={e => promoAction('apply', e.target.value)}
										value={data.useType}
									>
										<option value='full'>Apply full or Maximum value</option>
										<option value='specific'>Apply specific value</option>
										<option value='donation'>
											Apply value as Good Cause donation
										</option>
									</select>
								</div>
							</div>
							{data.useType === 'specific' && (
								<div className={`row form-group ${styles.alignItemsCenter}`}>
									<div className='col-8 col-lg-8'>
										<input
											type='text'
											className={`form-control ${styles.formControl}`}
											placeholder='Code here'
											value={voucher.specificValue}
											onChange={e =>
												setVoucher(val => ({
													...val,
													specificValue: e.target.value,
												}))
											}
										/>
									</div>
									<div className='col-4 col-lg-4'>
										<button
											className={`btn ${styles.btnCustom}`}
											onClick={() => promoAction('apply', data.useType)}
										>
											Apply
										</button>
									</div>
								</div>
							)}
						</>
					)}
				</>
			)}
		</div>
	);
};

export default memo(PromoCode);
